export default __webpack_public_path__ + "static/media/mint_person.4c69034c.svg";